import { isNud } from '@/utilities/typing';
import { dateYmd } from '@/utilities/date-format';
import Photographer from '@/models/entities/photographer';
import AlertDoubleBookingSchedule from '@/models/entities/alert-double-booking-schedule';

/**
 * アラートダブルブッキングトラン エンティティ
 */
class AlertDoubleBooking {
    alert_double_booking_id;
    alert_date;
    photographer;
    schedules;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.alert_double_booking_id = parseInt(properties.alert_double_booking_id, 10);
        this.photographer = new Photographer(properties.photographer);
        this.alert_date = properties.alert_date;
        this.schedules = [];
        if ('schedules' in properties) {
            for (let schedule of properties.schedules) {
                this.schedules.push(new AlertDoubleBookingSchedule(schedule));
            }
        }
    }

    get alert_date_display() {
        return dateYmd(this.alert_date);
    }
}

export default AlertDoubleBooking;
